<template>
  <div class="exchange-white">
    <!-- 白名单弹窗 -->
    <jd-dialog
      title="白名单"
      :visible="value"
      width="1000px"
      @close="handleClose"
      :isShowCancel="false"
      :isShowSure="false"
    >
      <jd-tip>
        <span
          >登记白名单的用户将不受活动参与条件限制，只要用户有足够的积分数，即可参与兑换奖品，但具体的可兑换次数和限制依旧生效</span
        >
      </jd-tip>
      <div class="exchange-white-btn">
        <jd-button @click="handleAdd">添加参与白名单</jd-button>
      </div>
      <!-- 白名单列表 -->
      <jd-table
        rowKey="id"
        :tableData="whitelistData"
        :tableInfo="tableInfo"
        :loading="tableLoading"
        :pageInfo="{
          pageNum: pageInfo.current,
          pageSize: pageInfo.size,
          total: pageInfo.total,
        }"
        @handlePage="handlePageWhite"
      >
        <template #operate="{ row }">
          <jd-button type="blueText" @click="handleDelete(row)">删除</jd-button>
        </template>
      </jd-table>
    </jd-dialog>

    <!-- 添加参与白名单弹窗 -->
    <jd-dialog
      title="新增白名单"
      width="500px"
      :visible.sync="addDialog"
      @close="handleAddClose"
    >
      <el-form
        ref="addFormRef"
        :model="addForm"
        :rules="addRules"
        class="new-input-box"
        label-width="auto"
      >
        <el-form-item label="添加方式：" prop="method">
          <el-radio-group
            v-model="addForm.addType"
            @change="handleAddTypeChange"
          >
            <el-radio :label="1">手动填写</el-radio>
            <el-radio :label="2">导入名单</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 手动填写 -->
        <el-form-item
          v-if="addForm.addType === 1"
          key="manual"
          label="用户PIN："
          prop="customerPin"
        >
          <el-input
            v-model="addForm.customerPin"
            placeholder="请输入京东账号名"
          ></el-input>
          <div class="exchange-white-hint">多个请用英文"，"隔开</div>
        </el-form-item>
        <!-- 导入名单 -->
        <el-form-item v-else key="import" label="上传文件：" prop="fileUrl">
          <div>
            <div class="exchange-white-download">
              <span>点击</span>
              <span class="exchange-white-download-link" @click="handleDownloadTemplate"
                >下载模板</span
              >
            </div>
            <el-upload
              ref="upload"
              drag
              accept=".xls,.xlsx"
              class="upload-box"
              action=""
              :auto-upload="false"
              :limit="1"
              :file-list="filelist"
              :on-change="handleChange"
              :on-remove="handleFileRemove"
            >
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <jd-button @click="handleAddClose">取消</jd-button>
        <jd-button type="blue" @click="handleAddConfirm">保存</jd-button>
      </div>
    </jd-dialog>
  </div>
</template>
<script>
import {
  pointActivityWhite,
  pointActivityAddOrUpdate,
  uploadWhiteListFile,
  deleteWhiteList
} from "@/api/jhk/paradiseAndTaskCommonController.js";
export default {
  name: "exchangeWhiteList",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    whiteRow: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // 接口暂未接入，白名单数据先存本地
      tableLoading: false,
      whitelistData: [],
      tableInfo: [
        {
          label: "用户PIN",
          prop: "chaosPin",
        },
        {
          label: "添加时间",
          prop: "updateTime",
        },
        {
          label: "操作",
          type: "operate",
          slot: "operate",
        },
      ],
      addDialog: false,
      addForm: {
        customerPin: "",
        addType: 1,
        fileName: "",
        fileUrl: "",
      },
      // 导入名单相关
      importFile: null,
      addRules: {
        customerPin: [
          { required: true, message: "请输入用户PIN", trigger: "blur" },
          {
            // 多个PIN仅支持英文逗号隔开
            validator: (rule, value, callback) => {
              if (value && /[，、；;\s]/.test(value)) {
                callback(new Error("多个用户PIN仅支持使用英文逗号隔开"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        // 导入名单需先上传文件
        fileUrl: {
          required: true,
          message: "请上传文件",
          trigger: "change",
        },
      },
      pageInfo: {
        current: 1,
        size: 10,
        total: 0,
      },
      filelist: [],
    };
  },
  created() {
    this.getDataList();
  },
  methods: {
    handlePageWhite({ pageNum, pageSize }) {
      this.pageInfo.current = pageNum;
      this.pageInfo.size = pageSize;
      this.getDataList();
    },
    getDataList() {
      const query = {
        current: this.pageInfo.current,
        size: this.pageInfo.size,
        activityId: this.whiteRow.id,
        activityType: 2,
      };
      this.tableLoading = true;
      pointActivityWhite(query)
        .then((res) => {
          this.tableLoading = false;
          this.whitelistData = res.data.records;
          this.pageInfo.total = Number(res.data.total);
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    // 添加参与白名单
    handleAdd() {
      this.addForm.addType = 1;
      this.addForm.customerPin = "";
      this.addForm.fileUrl = "";
      this.addForm.fileName = "";
      this.filelist = [];
      this.$refs.upload && this.$refs.upload.clearFiles();
      this.addDialog = true;
    },
    // 添加弹窗关闭
    handleAddClose() {
      this.addDialog = false;
      this.importFile = null;
      this.$refs.addFormRef && this.$refs.addFormRef.resetFields();
    },
    // 切换添加方式时清空校验提示
    handleAddTypeChange() {
      this.$nextTick(() => {
        this.$refs.addFormRef && this.$refs.addFormRef.clearValidate();
      });
    },
    // 保存添加的白名单
    handleAddConfirm() {
      this.$refs.addFormRef.validate((valid) => {
        if (!valid) return;
        const params = {
          ...this.addForm,
          activityType: 2,
          activityId: this.whiteRow.id,
        };
        try {
          pointActivityAddOrUpdate(params).then((res) => {
            if (res.code == 1) {
              this.$message.success("操作成功");
              this.handleAddClose();
              this.getDataList();
            } else {
              this.$message.error(res.message);
            }
          });
        } catch (error) {

        }
      });
    },
    // 导入名单的文件选择
    handleChange(file, fileList) {
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      if (!/\.(xls|xlsx)$/i.test(type || "")) {
        this.$message.warning("仅支持xls、xlsx格式的文件");
        this.handleFileReset();
        return false;
      }
      if (file.size > 50 * 1024 * 1024) {
        this.$message.warning("文件大小不能超过50MB");
        this.handleFileReset();
        return false;
      }
      let form = new FormData();
      form.append("file", file.raw);
      uploadWhiteListFile(5,form).then((res) => {
        if (res.code == 1) {
          this.addForm.fileUrl = res.data.fileUrl;
          this.addForm.fileName = file.fileName;
          this.$message.success("上传成功");
          // 上传成功后清除“请上传文件”的校验提示
          this.$nextTick(() => {
            this.$refs.addFormRef &&
              this.$refs.addFormRef.validateField("fileUrl");
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 导入名单的文件移除
    handleFileRemove() {
      this.filelist = [];
      this.addForm.fileUrl = "";
      this.addForm.fileName = "";
    },
    handleFileReset() {
      this.importFile = null;
      this.$refs.upload && this.$refs.upload.clearFiles();
    },
    // 导入名单保存（后端导入接口待接入，先抛出文件）
    handleImportConfirm() {
      if (!this.importFile) {
        this.$message.warning("请上传文件");
        return;
      }
      this.$emit("import", {
        file: this.importFile,
        activityId: this.whiteRow.id,
      });
      this.handleAddClose();
    },
    // 下载导入模板
    handleDownloadTemplate() {
      let url = "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E7%A7%AF%E5%88%86%E5%85%91%E6%8D%A2%E7%99%BD%E5%90%8D%E5%8D%95%E6%A8%A1%E6%9D%BF.xlsx";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      document.body.appendChild(elem);
      elem.click();
    },
    // 删除白名单
    handleDelete(row) {
      this.$confirm("是否删除该白名单用户吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          try {
            deleteWhiteList({
              id: row.id,
              activityId: this.whiteRow.id,
              activityType: 2,
            }).then((res) => {
              if (res.code == 1) {
                this.$message.success("删除成功");
                this.getDataList();
              } else {
                this.$message.error(res.message);
              }
            });
          } catch (error) {
            
          }
        })
        .catch(() => {});
    },
    // 弹窗关闭
    handleClose() {
      this.$emit("input", false);
    }
  },
};
</script>
<style lang="scss" scoped>
.exchange-white {
  &-btn {
    margin: 20px 0 16px;
  }
  &-hint {
    margin-top: 8px;
    font-size: 12px;
    line-height: 1;
    color: #999;
  }
  &-download {
    color: #333;
    &-link {
      margin-left: 4px;
      color: $theme-color;
      cursor: pointer;
    }
  }
 /deep/ .el-upload-dragger {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>
